const hyphenate = require('./hyphenate');

module.exports = {
    hyphenate,
};



// WEBPACK FOOTER //
// ./src/olycommon/stringhelpers/index.js